"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _createStyled = require("../../../utils/createStyled");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _option = _interopRequireDefault(require("../style/option"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

var emptyHandler = function emptyHandler() {};

var Option =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Option, _React$Component);

  function Option() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Option);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Option)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleClick", function () {
      var cb = function cb() {
        if (typeof _this.props.onClick === 'function') {
          _this.props.onClick(_this.props.id);
        }
      };

      if (_this.props.multiple) {
        /**
         * пришлось ставить задержку потому что Chrome генерит 2 события на button, которые нельзя остановить через stopPropagation
         * firefox в свою очередь не реагирует на клик по вложенному чекбоксу, от чего м ыне может завязаться на него
         */
        _this._selectDelayTimeout && clearTimeout(_this._selectDelayTimeout);
        _this._selectDelayTimeout = setTimeout(cb, 10);
      } else {
        cb();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Option, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          onKeyDown = _this$props.onKeyDown,
          onBlur = _this$props.onBlur,
          tabIndex = _this$props.tabIndex,
          isSelected = _this$props.isSelected,
          qaNode = _this$props.qaNode,
          qaValue = _this$props.qaValue,
          children = _this$props.children,
          theme = _this$props.theme,
          style = _this$props.style,
          multiple = _this$props.multiple,
          id = _this$props.id,
          styles = (0, _option["default"])(theme);
      var content = children;

      if (multiple) {
        content = _react["default"].createElement(_Checkbox["default"], {
          value: id,
          onChange: emptyHandler,
          style: {
            animationBackgroundColor: 'transparent',
            fontSize: theme.fontSize
          },
          checked: isSelected
        }, children);
      }

      return _react["default"].createElement(_createStyled.Styled.Button, {
        type: "button",
        title: title,
        onClick: this._handleClick,
        onKeyDown: onKeyDown,
        onBlur: onBlur,
        tabIndex: tabIndex,
        styles: isSelected ? styles.itemSelected : styles.item,
        "data-qa-node": qaNode,
        "data-qa-value": qaValue,
        style: style
      }, content);
    }
  }]);
  return Option;
}(_react["default"].Component);

Option.defaultProps = {
  tabIndex: '0'
};
Option.propTypes = {
  title: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  tabIndex: _propTypes["default"].string,
  qaNode: _propTypes["default"].string,
  qaValue: _propTypes["default"].string,
  isSelected: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  theme: _propTypes["default"].object,
  // react-virtual styles
  style: _propTypes["default"].object,
  multiple: _propTypes["default"].bool
};
var _default = Option;
exports["default"] = _default;